import AudioDownloadPlaceholder from '@/shared/assets/images/audio-download-feature.jpg';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Audio download',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreator,
  buttonText: BUTTON_TEXTS.toCreator,
  features: getBullets(['translate25', 'downloadGeneratedVoice', 'audioDownload', 'noWatermark']),
  media: {
    src: AudioDownloadPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.audioUpgradeChoosePlanModalClick,
  mixpanelOpeningEvent: MixpanelEvents.audioUpgradeModalShown,
  subtitle: 'Upgrade to Creator to download audio with generated voice or audio with voice and background sound',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

export const AUDIO_DOWNLOAD_CONTENT: LimitedFeatureContent = {
  starter: STARTER_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
